import { render, staticRenderFns } from "./CancelledDetails.vue?vue&type=template&id=90228f8e"
import script from "./CancelledDetails.vue?vue&type=script&lang=js"
export * from "./CancelledDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports